import { RESET_APP_STATE } from "./mutation-types";
import { getDefaultState } from "@/vuex/modules/app";
export default {
  resetAppState: ({ commit }) => {
    commit(RESET_APP_STATE, getDefaultState());
  }
};
